export default __webpack_public_path__ + "static/pnews_2-ebefbb6915a3be3ccb360fb38e85fcf8.jpg";